import { Cassette } from "@root/shared/components/Cassette";
import { type FC } from "react";
import { LazyLoadImage } from "@root/shared/components/LazyLoadImage";
import { type OptionProps, SelectBox } from "@root/shared/components/SelectBox";
import { type WorkContentAlbum } from "@clientFrontend/features/publication/type/type";
import { RoundButton } from "@root/shared/components/RoundButton";
import * as styles from "./styles.css";

type Props = {
  workContentAlbum: WorkContentAlbum;
  albumCategoryOptions: OptionProps[];
  index: number;
  selectedWorkContentAlbumsCount: number;
  handleChangeAlbumCategory: (albumCategoryId: number, clientImageId: number) => void;
  handleChangeAlbumSortNo: (currentSortNo: number, swapSortNo: number) => void;
};

export const AlbumCassette: FC<Props> = ({
  workContentAlbum,
  albumCategoryOptions,
  index,
  selectedWorkContentAlbumsCount,
  handleChangeAlbumCategory,
  handleChangeAlbumSortNo,
}) => {
  const paramsName = `work[work_contents_attributes][0][album_work_content_albums_attributes][${index}]`;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <span className={styles.sortNo}>{workContentAlbum.sortNo}枚目</span>
        <span className={styles.navButtons}>
          <RoundButton
            iconName="arrow-bold-left"
            disabled={index === 0}
            onClick={() =>
              handleChangeAlbumSortNo(workContentAlbum.sortNo, workContentAlbum.sortNo - 1)
            }
          />
          <RoundButton
            iconName="arrow-bold-right"
            disabled={index + 1 === selectedWorkContentAlbumsCount}
            onClick={() =>
              handleChangeAlbumSortNo(workContentAlbum.sortNo, workContentAlbum.sortNo + 1)
            }
          />
        </span>
      </div>
      <div className={styles.cassetteContainer}>
        <Cassette width="216" height="253" className={styles.customCassette}>
          <LazyLoadImage
            src={workContentAlbum.imageUrl || "/images/client_frontend/img_job_sample0a.png"}
            alt="企業画像"
            width={192}
            height={108}
          />
          <div className={styles.textBoxContainer}>
            <div className={styles.textWrapper}>
              <span className={styles.categorySelection}>カテゴリの選択</span>
              <span className={styles.optionalLabel}>任意</span>
            </div>
            <SelectBox
              options={albumCategoryOptions}
              selected
              onChange={(event) =>
                handleChangeAlbumCategory(
                  Number(event.target.value),
                  workContentAlbum.clientImageId,
                )
              }
              placeholder="選択しない"
              defaultValue={workContentAlbum.albumCategoryId}
            />
          </div>
        </Cassette>
      </div>

      {/* サーバーに送るためのparamsの値をここで定義 */}
      <>
        <input type="hidden" name={`${paramsName}[id]`} value={workContentAlbum.id || ""} />
        <input
          type="hidden"
          name={`${paramsName}[client_image_id]`}
          value={workContentAlbum.clientImageId}
        />
        <input
          type="hidden"
          name={`${paramsName}[album_category_id]`}
          value={workContentAlbum.albumCategoryId || ""}
        />
        <input type="hidden" name={`${paramsName}[sort_no]`} value={workContentAlbum.sortNo} />
      </>
    </div>
  );
};
